export default __webpack_public_path__ + "static/media/helical-spring.ad9211b2.jpg";